import React, { ReactNode } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Link as MuiLink } from '@material-ui/core';
import cc from 'classnames';

import styles from './Link.module.css';

type Props = {
  to: string,
  children: ReactNode,
  className?: string,
  onClick?: () => void,
};

const Link = ({ children, to, className, onClick }: Props) => (
  <MuiLink
    to={to}
    component={RouterLink}
    className={cc(styles.link, className)}
    onClick={onClick}
  >
    {children}
  </MuiLink>
);

export default Link;
